/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-11 13:15:38
 */
export default {
  path: '/',
  name: 'systemManage',
  hidden: true,
  component: resolve => require(['@/views/Application.vue'], m => resolve(m.default)),
  meta: {
    title: '系统',
    icon: 'fa fa-university iconTitle',
    level: 1,
    nav: 'sys',
    role: ['admin', 'topunion', 'levelunion']
  },
  children: [{
    path: '/SystemManage',
    name: 'SystemManage',
    hidden: true,
    meta: {
      title: '系统管理',
      level: 2,
      nav: 'sys',
      icon: 'fa fa-university iconTitle',
      role: ['admin', 'topunion', 'levelunion']
    },
    component: resolve => require(['@/views/systemmanage/SystemManage.vue'], m => resolve(m.default))
  },
  {
    path: '/Account',
    name: '账号管理',
    hidden: true,
    meta: {
      title: '账号管理',
      level: 2,
      nav: 'sys',
      role: ['admin', 'topunion', 'levelunion']
    },
    component: resolve => require(['@/views/system/Account.vue'], m => resolve(m.default))
  }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/route-sys.js